module.exports = __webpack_public_path__ + "static/media/independant-logo.bc5fb135.jpg";